import React from 'react';
import PropTypes from 'prop-types';
import { propTypes } from 'formsy-react';
import dynamic from 'next/dynamic';
import moment from 'moment';
import { registerLocale } from 'react-datepicker';
import sv from 'date-fns/locale/sv';
import withFormsyValidations from '../withFormsyValidations';

registerLocale('sv', sv);

// eslint-disable-next-line
const DatePickerInput = dynamic(() => import('react-datepicker'), {
  ssr: false,
});

class DatePicker extends React.Component {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      setValue: PropTypes.func,
      onChange: PropTypes.func.isRequired,
      minDate: PropTypes.bool,
      expanded: PropTypes.bool,
      ...propTypes,
    };
  }

  static defaultProps = {
    minDate: false,
    expanded: false,
    setValue: () => {},
  };

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(value) {
    const { name, setValue, onChange } = this.props;
    const fixedValue = moment(value).format('YYYY-MM-DD');
    setValue(fixedValue, false); // this is the performance thief
    onChange(name, fixedValue);
  }

  render() {
    // Dont remove onChange from below.
    const { value, errorMessage, isValid, minDate, expanded, ...extras } =
      this.props;
    const date = value ? moment(value).toDate() : undefined;
    return (
      <div>
        <DatePickerInput
          className={
            !isValid ? 'form-control border border-danger' : 'form-control'
          }
          selected={date}
          locale="sv"
          minDate={minDate ? moment().toDate() : undefined}
          showWeekNumbers
          timeFormat="HH:mm"
          timeIntervals={15}
          dateFormat="yyyy-MM-dd"
          autoComplete="off"
          wrapperClassName="d-block"
          inline={expanded}
          {...extras}
          onChange={this.changeValue}
        />
        <span>{errorMessage}</span>
      </div>
    );
  }
}
export { DatePicker };

export default withFormsyValidations(DatePicker);
